export const iconNames = {
    EDIT: 'edit',
    CROSS: 'cross',
    SAVE: 'save',
    EYE: 'eye',
    DELETE: 'delete',
    SEARCH: 'search',
    PRINT: 'print',
    WORK: 'work',
    EDIT_REQUEST: 'editRequest',
    IMAGE_AUTO: 'imageAuto',
    IMAGE_PTC: 'imagePTS',
    NOIMAGE: 'noImage',
    NORESULTS: 'noResults',
    DOWNLOAD: 'download'
  }